(function () {
  'use strict';

  /* @ngdoc object
   * @name wbFaq
   * @description
   *
   */
  angular
    .module('wbFaq', [
      'ui.router',
      'wbResource'
    ]);
}());
